<template lang="pug">
  .MenuSearchInput(ref="container" @click="goToSearch" @mouseover="toggleHover()" @mouseout="toggleHover()")
    form(method="POST", action="", autocomplete="off", :class="{ 'is-disabled': processing }", @submit.prevent="submit")
      input.search(ref="input" @focus="toggleFocus()" @blur="toggleFocus()" type="text", name="input", value="" @input="clearPlaceholder()")
      div(ref='placeholder').MenuSearchInput_placeholder {{ $t('menu.search.placeholderBase') }}
      input.submit(type="submit" value="")
      img.magnifier(src="/img/ui/magnifier.svg")
</template>

<script>
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'
import i18n from '@/i18n'
import router from '@/router'

export default {
  data () {
    return {
      processing: false,
      focus: false,
      random: 0,
      placeholder: this.$t('menu.search.placeholder')
    }
  },
  computed: {
    ...mapGetters(['searchQuery', 'menuOpened'])
  },
  methods:
  {
    ...mapActions([
      'setSearchQuery'
    ]),
    submit () {

    },
    toggleHover () {
      if (this.focus) return
      this.$el.classList.toggle('MenuSearchInput_is-hover')
    },
    toggleFocus () {
      // if (event.type == 'focus') { this.focus = true } else { this.focus = false }

      // this.$el.classList.toggle('MenuSearchInput_is-focus')
      // this.$el.classList.remove('MenuSearchInput_is-hover')

      // this.$refs.input.value = ''

      // this.randomPlaceholder()
    },
    placeholderTransition (string = this.$t('menu.search.placeholderBase'), delay = 0) {
      TweenMax.to('.MenuSearchInput_placeholder', 0.6, { delay: delay,
        opacity: 0,
        x: 10,
        letterSpacing: 4,
        y: '-50%',
        onComplete: () => {
          if (this.$refs.placeholder) { this.$refs.placeholder.innerText = string }

          this.random = this.random < (this.placeholder.length - 1) ? this.random += 1 : 0
          TweenMax.to('.MenuSearchInput_placeholder', 0.6, { opacity: 1, x: 0, y: '-50%', letterSpacing: 2 })
        } })
    },
    clearPlaceholder () {
      clearInterval(this.inverval)
      TweenMax.to('.MenuSearchInput_placeholder', 0.2, { opacity: 0 })

      this.updateInput(event.target.value)
    },
    randomPlaceholder () {
      if (this.$refs.input.value.length <= 0 && this.focus) {
        this.placeholderTransition(this.placeholder[this.random], 0.4)

        this.inverval = setInterval(() => {
          this.placeholderTransition(this.placeholder[this.random])
        }, 2500)
      } else {
        clearInterval(this.inverval)
        this.placeholderTransition()
      }
    },
    updateInput (e) {
      // store.dispatch('setMenuOpen', false)
      // this.setSearchQuery(e)
      // document.body.querySelector('#HeaderSearchInput').focus()
    },
    goToSearch () {
      store.dispatch('setMenuOpen', false)

      if (this.$router.currentRoute.name !== 'search') {
        router.push(i18n.locale == 'fr' ? '/fr/recherche' : '/en/search')
      }
      this.setSearchQuery('')
    }
  }
}

</script>

<style lang="stylus" scope>

.MenuSearchInput

  background-color: $black
  height 40px
  border-radius: @height;
  width 100%
  transition all 0.8s $ease
  margin-bottom 20px

  @media $mq_m
    height 60px
    border-radius: @height;
    margin-bottom 20px
    width calc(100% - 150px)

  @media $mq_xl
    height 80px
    border-radius: @height;
    width 100%

  @media screen and (max-height: 850px)

    margin-bottom 20px

  &_placeholder

    font-size: 22px;
    line-height 1.2em
    letter-spacing 2px
    color: $beige
    font-size: 12px;
    top 50%
    left 0px
    transform translateY(-50%)
    position absolute
    pointer-events none
    touch-action none
    box-sizing border-box
    padding 0px 25px
    transition letter-spacing 1.2s $ease

    @media $mq_m
      padding 0px 35px
      font-size: 18px;

    @media $mq_l
      padding 0px 45px
      font-size: 22px;

    @media $mq_xl
      padding 0px 55px

  &_is-hover

    opacity 0.7!important

    .MenuSearchInput_placeholder

      letter-spacing 3px!important
      // transform translateX(-3px) translateY(-50%)

  form

    width 100%
    height 100%
    display flex
    flex-direction row
    position relative

  .search

    height 100%
    box-shadow none
    margin auto auto auto 0px
    background-color transparent
    font-size: 12px;
    line-height 1.2em
    color: $beige
    letter-spacing: 2px;
    padding 0px 20px
    box-sizing border-box
    transition all 1.2s $ease
    width 100%
    appearance none

    @media $mq_m
      padding 0px 30px
      font-size: 18px;

    @media $mq_l
      padding 0px 40px
      font-size: 22px;

    @media $mq_xl
      padding 0px 50px

    &::placeholder
      color: $beige

  .submit

    margin auto 0px auto auto
    width 105px
    height 100%
    appearance none
    position relative
    z-index 1
    padding 0px
    opacity 0
    cursor pointer

  .magnifier

    top 50%
    position absolute
    right 20px
    pointer-events none
    transform translateY(-50%)
    transition transform 0.8s $ease
    width 18px
    height 18px

    &:hover

      transform translateY(-50%) scale(0.8)

    @media $mq_m
      right 30px
      width 22px
      height 22px

    @media $mq_l
      right 40px
      width 26px
      height 26px

</style>
